<template>
  <div class="detailMain">
    <div class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index)  in routeList" :key="index"
        :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never">
      <div class="cardTop">
        <h1>{{ detailData.name }}</h1>
        <h2>
          <i v-if="detailData.onlineStatus==0" class="redDot"></i>
          <i v-if="detailData.onlineStatus==1" class="greenDot"></i>
          {{detailData.onlineStatus==0?"离线":detailData.onlineStatus==1?"在线":"---"}}
        </h2>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            操作<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="edit">编辑</el-dropdown-item>
            <el-dropdown-item command="del">删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="cardBottom">
        <el-tabs tab-position="left" style="height: 520px;" @tab-click="tabClick">
          <el-tab-pane label="详情">
            <h1>网关详情</h1>
            <el-row class="formRow">
              <el-col :span="12" v-if="commuType == 3">
                <div class="grid-content bg-purple">
                  <label>mqtt用户名</label> <br />
                  <span>{{ detailData.mqttUsername }}</span>
                </div>
              </el-col>
              <el-col :span="12" v-if="commuType == 3">
                <div class="grid-content bg-purple">
                  <label>mqtt密码</label> <br />
                  <span>{{ detailData.mqttPassword }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>编号</label> <br />
                  <span>{{ detailData.code }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>名称</label> <br />
                  <span>{{ detailData.name }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>品牌</label> <br />
                  <span>{{
                    detailData.brandObj != null ? detailData.brandObj : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>型号</label> <br />
                  <span>{{
                    detailData.modelObj != null ? detailData.modelObj : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>操作系统</label> <br />
                  <span>{{
                    detailData.osObj != null ? detailData.osObj : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>北向联网方式（网关到云平台）</label> <br />
                  <span>{{
                    detailData.northLinkTypeObj != null
                      ? detailData.northLinkTypeObj
                      : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <label>南向联网方式（网关到设备）</label> <br />
                  <span>{{
                    detailData.southLinkTypeObj != null
                      ? detailData.southLinkTypeObj
                      : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <label>备注</label> <br />
                  <span>{{
                    detailData.remarks != null ? detailData.remarks : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>加密类型</label> <br />
                  <span v-if="detailData.encryptType == 1">sm2加密</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>网关加密公钥</label> <br />
                  <span>{{ detailData.pubkeyUp }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>网关解密私钥</label> <br />
                  <span>{{ detailData.prikeyDown }}</span>
                </div>
              </el-col>
            </el-row>
            <h1 style="margin-top:30px">系统信息</h1>
            <el-row class="formRow">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>创建人</label> <br />
                  <span>{{
                    detailData.creator != null ? detailData.creator : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>创建时间</label> <br />
                  <span>{{
                    detailData.createDate != null
                      ? changeDate(detailData.createDate)
                      : "---"
                  }}</span>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="协议" class="protocol">
            <h1>网关协议</h1>
            <el-row :gutter="15" class="formRow">
              <el-col :span="8" v-if="agreementShow">
                <div @click="jumpDetail(agreement.id)">
                  <el-card shadow="hover">
                    <label>{{agreement.name}}</label> <br />
                    <span>{{agreement.remarks}}</span>
                  </el-card>
                </div>
              </el-col>
              <p style="line-height:50px;margin-left:20px;" v-if="!agreementShow">{{agreementTips}}</p>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="子设备">
            <h1>子设备信息</h1>
            <el-table :data="subDeviceData" height="450px">
              <el-table-column prop="id" label="设备编号">
                <template slot-scope="scope">
                  <el-button class="tableButton" @click="detailBtn(scope.row.id)">
                    {{ scope.row.code }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="设备名称"> </el-table-column>
              <el-table-column prop="onlineStatus" label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.onlineStatus == 0">
                    <i class="redDot"></i>离线</span>
                  <span v-else-if="scope.row.onlineStatus == 1">
                    <i class="greenDot"></i>在线</span>
                  <span v-else>---</span>
                </template>
              </el-table-column>
              <el-table-column prop="lastUpDate" label="最后一次获取数据时间">
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
  </div>
</template>
<script>
  import API from "../../api/api";
  import dayjs from "dayjs";
  export default {
    data() {
      return {
        commuType: sessionStorage.getItem('commuType'),
        routeList: this.$route.meta.routeList,
        ids: this.$route.query.id,
        detailData: {},
        subDeviceData: [], //子设备信息
        agreement: {}, //协议
        agreementShow: false,
        agreementTips: '',
      };
    },
    created() {},
    methods: {

      //格式化时间
      changeDate(time) {
        return dayjs(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      },

      //获取网关详情
      getPlatformMduModule() {
        API.platformMduModule(this.ids).then(res => {
          if (res.code == 1) {
            this.detailData = res.data;
          }
        });
      },

      //选择对应的tab时触发事件
      tabClick(val) {
        let _API = API
        let _this = this
        if (val.label == "协议") {
          //根据网关查找协议
          _API.platformMduModuleModuleProtocolID(_this.ids).then(res => {
            if (res.code == 1) {
              this.agreementShow = true
              _this.agreement = res.data.protocol;
            } else {
              this.agreementShow = false
              this.agreementTips = res.msg;

            }
          });
        }
        if (val.label == "子设备") {
          //根据网关查找设备
          _API.platformMduModuleDevice(_this.ids).then(res => {
            if (res.code == 1) {
              _this.subDeviceData = res.data.device;
            }
          });
        }
      },
      //跳转协议详情
      jumpDetail(id) {
        this.$router.push({
          path: "/device/moduleProtocolDetails",
          query: {
            id: id
          }
        });
      },
      //操作下拉
      handleCommand(para) {
        if (para == "edit") {
          //编辑
          this.$router.push({
            path: "/device/moduleAdd",
            query: {
              id: this.ids,
              flag: 'edit'
            }
          });
        } else if (para == "del") {
          //删除
          let para = {
            ids: this.ids
          }
          this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            API.delPlatformMduModule(para).then(res => {
              if (res.code == 1) {
                this.$message.success('删除成功');
                this.$router.push({
                  path: "/device/moduleManagement",
                });
              } else {
                var falseList = res.data;
                var errMsgStr;
                falseList.forEach(errMsg => {
                  errMsgStr = errMsg.substring(errMsg.indexOf('删除失败'))
                  return;
                })
                this.$message.error(errMsgStr);
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
      },
    },
    mounted() {
      this.getPlatformMduModule();
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/moduleDetail.vue